import { NgModule } from '@angular/core';
import { SubPathColorDirective } from '@dossier/shared/directives/sub-path-color.directive';

@NgModule({
  declarations: [
    SubPathColorDirective
  ],
  exports: [
    SubPathColorDirective
  ]
})
export class DossierDirectivesModule {
}
